import { useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { emptyOption } from "../../../../constants";
import { getAbogados } from "../../../../redux/Sections/Abogados/actions";
import { getGrupoEtapas, getTipoEtapas } from "../../../../redux/Sections/Estados/actions";
import { getTipoDocumentos } from "../../../../redux/Sections/TipoDocumento/actions";
import { useUser } from "../../../../hooks/useUser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEraser } from "@fortawesome/free-solid-svg-icons";
import Select from "../../../../components/Select";
import { setLoading } from "../../../../redux/Loading/actions";
import { situacionesService } from "../../../../_services/situaciones.service";


export const GestionFilter = ({ showFilter, setShowFilter, action, filters, setFilters, setShowTable, type, abogadoFilter }) => {
  const { abogadosList } = useSelector(e => e.dashboard);
  const dispatch = useDispatch();
  const user = useUser();

  const {
    register,
    control,
    handleSubmit,
    reset,
  } = useForm({});

  const [grupo, setGrupo] = useState();
  const [tipo, setTipo] = useState("");

  const [situaciones, setSituaciones] = useState([]);
  const [situacion, setSituacion] = useState("");

  const [abogado, setAbogado] = useState("");
  useEffect(() => {
    const getData = () => {
      dispatch(getAbogados());
      dispatch(getTipoDocumentos());
      dispatch(getGrupoEtapas());
    };

    getData();
  }, []);

  useEffect(() => {
    if (grupo && grupo.id) {
      dispatch(getTipoEtapas(grupo.id));
    }
  }, [grupo]);

  useEffect(() => {
    const getData = async () => {
      dispatch(setLoading(true));

      let response = await situacionesService.getSituaciones();

      if (response?.length) {
        setSituaciones(response.map(e => {
          return {
            ...e,
            value: e.CODIGO,
            label: e.DETALLE_SITUACION
          };
        }));

        dispatch(setLoading(false));
      }
      else {
        dispatch(setLoading(false));
      }
    };

    getData();
  }, []);

  const handleClean = () => {
    reset({});
    setFilters({});
    setTipo("");
    setGrupo("");
    setAbogado("");
  };

  const onSubmit = (data) => {
    setShowTable(false);

    // data.tpdni = typeId?.value;

    for (const value in data) {
      if (!data[value]) {
        delete data[value];
      }
    }

    if (data.nombre) {
      data.nombre = data.nombre.toUpperCase();
    }

    if (+data.nro) {
      data.nro = +data.nro;
    }

    data.abogado = abogadoFilter;

    setFilters(data);

    action(data);

    setShowFilter(false);
    setShowTable(true);
  };

  const fieldsName = [
    {
      name: "nombre",
      label: "Nombre",
    },
    {
      name: "domicilio",
      label: "Domicilio",
    },
    {
      name: "barrio",
      label: "Barrio",
    },
    {
      name: "imponible",
      label: "Número Imponible",
    },
    {
      name: "recurso",
      label: "Recurso",
    },
    {
      name: "estado",
      label: "Estado",
      value: tipo?.nombre
    },
    {
      name: "gp_estado",
      label: "Grupo",
      value: grupo?.nombre
    },
    {
      name: "abogado",
      label: "Abogado",
    },
    //
    //
    {
      name: "com",
      label: "N° de Comercio",
    },
    {
      name: "cc",
      label: "CUIT",
    },
    {
      name: "contrib",
      label: "Contribuyente",
    },
    {
      name: "fant",
      label: "Fantasía",
    },
    {
      name: "calle",
      label: "Calle",
    },
    {
      name: "nro",
      label: "Altura",
    },
  ];

  return (
    <div className="filter-container" >
      {showFilter ? (
        <Form onSubmit={handleSubmit(onSubmit)} >
          {type === "inmuebles" ? (
            <>
              <Row>
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">Contribuyente</Form.Label>
                  <Form.Control
                    name="nombre"
                    {...register("nombre")}
                  />
                </Col>
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">N° imponible</Form.Label>
                  <Form.Control
                    name="imponible"
                    {...register("imponible")}
                  />
                </Col>
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">Recurso</Form.Label>
                  <Form.Control
                    name="recurso"
                    {...register("recurso")}
                  />
                </Col>
              </Row>
              <Row >
                {user?.abogado === "A00" ? (
                  <Col sm={12} md={4} className="mt-3">
                    <Form.Label className="mb-2">Abogado</Form.Label>
                    <Controller
                      name="abogado"
                      control={control}
                      render={({ field: { onChange } }) => {
                        let options = abogadosList?.length ? abogadosList.map(e => {
                          return {
                            ...e,
                            value: e.codexterno,
                            label: `${e.apellido} ${e.nombre}`
                          };
                        }) : [];

                        return (
                          <Select
                            options={options?.length ? [emptyOption, ...options] : [emptyOption]}
                            onChange={(e) => {
                              setAbogado(e);
                              return onChange(e.value);
                            }}
                            value={abogado}
                          />
                        );
                      }}
                    />
                  </Col>
                ) : null}

                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">Estados</Form.Label>
                  <Controller
                    name="situacion"
                    control={control}
                    render={({ field: { onChange } }) => {
                      return (
                        <Select
                          options={situaciones?.length ? [emptyOption, ...situaciones] : [emptyOption]}
                          value={situacion}
                          onChange={(e) => {
                            setSituacion(e);
                            return onChange(e?.value);
                          }}
                        />
                      );
                    }}
                  />
                </Col>
              </Row>

              <Row>
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">Barrio</Form.Label>
                  <Form.Control
                    name="barrio"
                    {...register("barrio")}
                  />
                </Col>
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">Calle</Form.Label>
                  <Form.Control
                    name="calle"
                    {...register("calle")}
                  />
                </Col>
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">Altura</Form.Label>
                  <Form.Control
                    name="altura"
                    {...register("altura")}
                  />
                </Col>
              </Row>

              <Row>
                <Col sm={12} md={4} className="mt-3">
                  <Form.Label className="mb-2">Partida Inmobiliaria</Form.Label>
                  <Form.Control
                    name="partida"
                    {...register("partida")}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Circ</Form.Label>
                  <Form.Control
                    name="circ"
                    {...register("circ")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Secc</Form.Label>
                  <Form.Control
                    name="secc"
                    {...register("secc")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Ch Nro</Form.Label>
                  <Form.Control
                    name="chN"
                    {...register("chN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Ch Lta</Form.Label>
                  <Form.Control
                    name="chL"
                    {...register("chL")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Qt Nro</Form.Label>
                  <Form.Control
                    name="qtN"
                    {...register("qtN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Qt Lta</Form.Label>
                  <Form.Control
                    name="qtL"
                    {...register("qtL")}
                  />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Fr Nro</Form.Label>
                  <Form.Control
                    name="frN"
                    {...register("frN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Fr Lta</Form.Label>
                  <Form.Control
                    name="frL"
                    {...register("frL")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Mz Nro</Form.Label>
                  <Form.Control
                    name="mzN"
                    {...register("mzN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Mz Lta</Form.Label>
                  <Form.Control
                    name="mzL"
                    {...register("mzL")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Pc Nro</Form.Label>
                  <Form.Control
                    name="pcN"
                    {...register("pcN")}
                  />
                </Col>
                <Col className="col-auto" sm={12} md={2}>
                  <Form.Label className="my-2">Pc Lta</Form.Label>
                  <Form.Control
                    name="pcL"
                    {...register("pcL")}
                  />
                </Col>
              </Row>

              <Row className="mt-3">
                <Col className="col-auto" sm={12} md={4}>
                  <Form.Label className="my-2">Sub Pc</Form.Label>
                  <Form.Control
                    name="sbPc"
                    {...register("sbPc")}
                  />
                </Col>
              </Row>
            </>
          ) : (
            <>
              <Row>
                <Col sm={12} md={6} className="mt-3">
                  <Form.Label className="mb-2">N° de Comercio</Form.Label>
                  <Form.Control
                    name="com"
                    {...register("com")}
                  />
                </Col>
                <Col sm={12} md={6} className="mt-3">
                  <Form.Label className="mb-2">CUIT</Form.Label>
                  <Form.Control
                    name="cc"
                    {...register("cc")}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={6} className="mt-3">
                  <Form.Label className="mb-2">Contribuyente</Form.Label>
                  <Form.Control
                    name="contrib"
                    {...register("contrib")}
                  />
                </Col>
                <Col sm={12} md={6} className="mt-3">
                  <Form.Label className="mb-2">Fantasía</Form.Label>
                  <Form.Control
                    name="fant"
                    {...register("fant")}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm={12} md={6} className="mt-3">
                  <Form.Label className="mb-2">Calle</Form.Label>
                  <Form.Control
                    name="calle"
                    {...register("calle")}
                  />
                </Col>
                <Col sm={12} md={6} className="mt-3">
                  <Form.Label className="mb-2">Altura</Form.Label>
                  <Form.Control
                    name="nro"
                    type="number"
                    {...register("nro")}
                  />
                </Col>
              </Row>
            </>
          )}

          <Row className=" d-flex justify-content-end" >
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="button"
                variant="danger"
                onClick={handleClean}
                className="danger-button d-flex align-items-center"
              >
                <FontAwesomeIcon icon={faEraser} size="1x" /><span className="ml-2">LIMPIAR</span>
              </Button>
            </Col>
            <Col style={{ maxWidth: 122 }}>
              <Button
                type="submit"
                className="custom-button"
              >
                BUSCAR
              </Button>
            </Col>
          </Row>
        </Form>
      ) : null}

      <>
        {
          <Row className="d-flex justify-content-start mt-4" style={{ paddingLeft: 15 }}>
            <div className="filterby">
              <h5 style={{ marginTop: "2px", fontWeight: 700 }} >Filtrado por:</h5>
            </div>
            {!Object.values(filters).filter((e) => e !== "").length && (
              <div className="tags">
                <span
                  key="sinopciones"
                >
                  No hay opciones seleccionadas
                </span>
              </div>
            )}

            {fieldsName.map((e) => {
              return (filters[e.name] || filters[e.name] === 0) && (
                <div className="tags" key={e.name}>
                  <span color="green" key={e.name}>
                    {e.label} : {e.value || filters[e.name]}
                  </span>
                </div>
              );
            })}
          </Row>
        }
      </>
    </div>
  );
};
